<template>
  <form @submit.prevent="onSubmit">
    <p v-if="messageSuccess" class="mt-0 text-center text-success">
      <b>{{ messageSuccess ? messageSuccess : '' }}</b>
    </p>
    <p v-if="messageFailure" class="mt-0 text-center text-danger">
      <b>{{ messageFailure ? messageFailure : '' }}</b>
    </p>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="buteur_joueur">Joueurs</label>
      </div>
      <select id="buteur_joueur"
              v-model="dataForm.joueur_id"
              class="custom-select"
              name="buteur_joueur">
        <option :key="joueur.joueur_id.slice(5,15)"
                :value="joueur.joueur_id"
                v-for="joueur in joueurs">
          {{ joueur.prenom.charAt(0).toUpperCase() + joueur.prenom.slice(1).toLowerCase() }}
          {{ joueur.postnom.charAt(0).toUpperCase() + joueur.postnom.slice(1).toLowerCase() }}
          {{ joueur.nom.charAt(0).toUpperCase() + joueur.nom.slice(1).toLowerCase() }}
        </option>
      </select>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="buteur_nombre_buts">Nombre de buts</label>
      </div>
      <input id="buteur_nombre_buts"
             v-model="dataForm.nombre_buts"
             class="form-control"
             name="buteur_nombre_buts"
             placeholder="Entrez le nombre de buts"
             type="number">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="buteur_match">Match</label>
      </div>
      <select id="buteur_match"
              v-model="dataForm.match_id"
              class="custom-select"
              name="buteur_match">
        <option :key="match.match_id.slice(5,15)"
                :value="match.match_id"
                v-for="match in matchs">
          {{
            (equipes) ?
            (
                equipes.filter((equipe) => equipe.equipe_id === match.equipe_a_id)[0].nom.toUpperCase() + ' vs ' +
                equipes.filter((equipe) => equipe.equipe_id === match.equipe_b_id)[0].nom.toUpperCase() + ' (' +
                (new Date(match.date_rencontre).toLocaleDateString() + match.temps_rencontre) + ')'
            ) : ''
          }}
        </option>
      </select>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="buteur_saison">Saisons</label>
      </div>
      <select id="buteur_saison"
              v-model="dataForm.saison_id"
              class="custom-select"
              name="buteur_saison">
        <option :key="saison.saison_id.slice(5,15)"
                :value="saison.saison_id"
                v-for="saison in saisons">
          {{ saison.annee_debut }} - {{ saison.annee_fin  }}
        </option>
      </select>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-append">
        <label class="input-group-text" for="buteur_commentaires">Commentaires</label>
      </div>
      <textarea id="buteur_commentaires"
                v-model="dataForm.commentaires"
                class="form-control"
                name="buteur_commentaires"
                placeholder="Entrez un court commentaire sur le buteur"
                type="email">
      </textarea>
    </div>
    <div class="mt-4 mb-3 text-center">
      <button class="btn btn-sm btn-success" type="submit">SAUVEGARDER</button>
    </div>
  </form>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from 'vuex'

export default {
  name: "Create",
  props: {},
  data() {
    return {
      joueurs: null,
      saisons: null,
      equipes: null,
      matchs: null,
      messageSuccess: '',
      messageFailure: '',
      dataForm: {
        joueur_id: '',
        saison_id: '',
        match_id: '',
        nombre_buts: '',
        commentaires: '',
        table: 'buteurs',
      }
    }
  },
  watch: {
    messageSuccess : function () {
      let vm = this;
      setTimeout( () => vm.messageSuccess = "", 5000)
    },
    messageFailure : function () {
      let vm = this;
      setTimeout( () => vm.messageFailure = "", 5000)
    }
  },
  components: {},
  methods: {
    ...mapMutations([]),
    ...mapActions([
      'axiosGetAllData',
      'axiosPostData',
    ]),
    onSubmit() {
      this.axiosPostData(this.dataForm)
          .then((data) => {
            if((data.data.status === 'reussite' && data.status) === 201)
              this.messageSuccess = "Buteur ajouté avec succès !"
            else
              this.messageFailure = "Une erreur est survenue lors de l'insertion du buteur !"
          })
          .catch((error) => {
            this.messageFailure = "Une erreur est survenue lors de l'insertion du buteur !"
          })
    }
  },
  computed: {
    ...mapGetters([])
  },
  beforeCreate() {
  },
  created() {
    //
    this.axiosGetAllData({
      table: 'equipes'
    })
        .then((data) => {
          this.equipes = data.data
        })
        .catch((data) => {
          this.equipes = data
        })
    //
    this.axiosGetAllData({
      table: 'matchs_joues'
    })
        .then((data) => {
          this.matchs = data.data
        })
        .catch((data) => {
          this.matchs = data
        })
    //
    this.axiosGetAllData({
      table: 'joueurs'
    })
        .then((data) => {
          this.joueurs = data.data
        })
        .catch((data) => {
          this.joueurs = data
        })
    //
    this.axiosGetAllData({
      table: 'saisons'
    })
        .then((data) => {
          this.saisons = data.data
        })
        .catch((data) => {
          this.saisons = data
        })
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeUpdate() {
  },
  updated() {
  },
  beforeDestroy() {
  },
  destroyed() {
  }
}
</script>

<style lang="scss" scoped>
form {
  & > div {
    & > div {
      & > label, & > label {
        background-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
        color: var(--color-white, rgba(255, 255, 255, 1));
        border-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
      }

      & > label.customized-label {
        padding: 0.25rem 0.5rem;
        font-size: 0.875rem;
        line-height: 1.5;
        border-radius: 0.2rem;
      }
    }

    & > input, & > select {
      border-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/buteurs/components/Create.vue